import {remCalc} from '_themeUtils'

const form = {
    Form: {
        baseStyle: {
            requiredIndicator: {
                color: 'color.text.black',
                ml: 0,
            },
            container: {
                pb: 'spacing.1',
                'input, textarea': {
                    _invalid: {
                        borderColor: 'color.border.input.error',
                        boxShadow: 'none',
                        _hover: {
                            borderColor: 'color.border.input.error',
                            boxShadow: 'none',
                        },
                        _focusVisible: {
                            borderColor: 'color.border.input.error',
                            boxShadow: 'none',
                        },
                    },
                },
                label: {
                    '&:not(.chakra-checkbox):not(.chakra-radio)': {
                        textStyle: 'paragraphSm',
                        color: 'color.text.black',
                        letterSpacing: remCalc(1),
                        fontWeight: 400,
                        // Per Figma 58195-11032 the input label is indented inward from the box
                        // edge on every breakpoint (mobile included), matching the select label
                        // (select.ts). Fixed spacing.3 so all form labels stay aligned to each
                        // other and offset from the input box.
                        pl: 'spacing.3',
                        pb: 'spacing.1',
                        m: 0,
                    },
                    '&.chakra-radio': {
                        textStyle: 'paragraphSm',
                        color: 'color.text.black',
                        letterSpacing: remCalc(1),
                        fontWeight: 400,
                        pb: 'spacing.1',
                        pr: 'spacing.3',
                        m: 0,
                    },
                },
                '.chakra-form__error-message': {
                    pos: 'absolute',
                    transform: 'translateY(-24px)',
                    textStyle: 'paragraphXs',
                    letterSpacing: remCalc(0.5),
                    fontWeight: 400,
                    color: 'color.text.error',
                    mt: 'spacing.2',
                    pl: 'spacing.3',
                },
                '.chakra-input__right-element': {
                    w: 'auto',
                    h: 'size.input.height',
                    pr: 'spacing.3',
                    cursor: 'pointer',
                },
                '.chakra-input__left-element': {
                    w: 'auto',
                    h: 'size.input.height',
                    pl: 'spacing.3',
                    cursor: 'pointer',
                },
                textarea: {
                    height: remCalc(128),
                },
            },
        },
    },
}
export default form
